const themes = {
  github: {
    main: 'line-height:1.3;color:#000000;background:#ffffff;overflow:auto;',
    error: 'line-height:1.3;color:#66d9ef;background:#272822;overflow:auto;',
    key: 'color:#000000;',
    string: 'color:#d14;',
    value: 'color:#099;',
    boolean: 'color:#000000;font-weight:bold;',
  },
}

export const github = themes.github

export default themes
